import React from 'react';

import EmailInput from './emailInput';
import { getInitialValueForFormGroup } from './helperFunction';
import MyinfoOtpInput from './myinfoOtpInput';

const EmailFlowControl = ({ keyValue, myinfoData, flowType, ...props }) => {
  // view should be "input" or "otp"
  const [toggleView, setToggleView] = React.useState('input');
  const initialValue = getInitialValueForFormGroup(myinfoData.data, keyValue);
  const [value, setValue] = React.useState(initialValue);

  return toggleView === 'input' ? (
    <EmailInput
      {...props}
      setToggleView={setToggleView}
      value={value}
      setValue={setValue}
      myinfoData={myinfoData}
      keyValue={keyValue}
      flowType={flowType}
    />
  ) : (
    <MyinfoOtpInput
      {...props}
      setToggleView={setToggleView}
      value={value}
      keyValue={keyValue}
      myinfoData={myinfoData}
      flowType={flowType}
    />
  );
};

export default EmailFlowControl;
